// hooks/useKioskManifest.js
// Dynamically swaps the PWA manifest <link> so each kiosk installs as a separate app.
import { useEffect } from 'react';

export default function useKioskManifest(manifestPath, themeColor) {
  useEffect(() => {
    const link = document.querySelector('link[rel="manifest"]');
    const meta = document.querySelector('meta[name="theme-color"]');
    const prev = link ? link.getAttribute('href') : null;
    const prevColor = meta ? meta.getAttribute('content') : null;

    if (link) link.setAttribute('href', manifestPath);
    if (meta && themeColor) meta.setAttribute('content', themeColor);

    return () => {
      // Restore original on unmount
      if (link && prev) link.setAttribute('href', prev);
      if (meta && prevColor) meta.setAttribute('content', prevColor);
    };
  }, [manifestPath, themeColor]);
}
